import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const UmbrellaIllustration = ({ width = 36, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 372 400">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#FFF"
                  d="M127.905.189c-4.818 0-8.726 3.916-8.719 8.743V231.58c0 8.024-6.46 14.56-14.403 14.56-7.945 0-14.404-6.536-14.404-14.56 0-4.827-3.9-8.742-8.719-8.742-4.817 0-8.718 3.915-8.718 8.742 0 17.664 14.282 32.038 31.84 32.038 9.11 0 17.317-3.894 23.123-10.081 5.386-5.738 8.719-13.456 8.719-21.957V8.932c0-4.827-3.901-8.743-8.72-8.743"
                  opacity=".1"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#C6C6C6"
                  d="M127.905.189c-4.818 0-8.726 3.916-8.719 8.743V231.58c0 8.024-6.46 14.56-14.403 14.56-7.945 0-14.404-6.536-14.404-14.56 0-4.827-3.9-8.742-8.719-8.742-4.817 0-8.718 3.915-8.718 8.742 0 17.664 14.282 32.038 31.84 32.038 9.11 0 17.317-3.894 23.123-10.081 5.386-5.738 8.719-13.456 8.719-21.957V8.932c0-4.827-3.901-8.743-8.72-8.743"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#004C90"
                  d="M.188 120.713c-.008.029-.185 1.666-.185 1.801v14.567c0 4.827 3.9 8.736 8.719 8.736 4.817 0 8.718-3.91 8.718-8.736v-5.831h110.467V14.753c-62.204 0-115.888 44.554-127.72 105.96"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#FFF"
                  d="M.188 120.713c-.008.029-.185 1.666-.185 1.801v14.567c0 4.827 3.9 8.736 8.719 8.736 4.817 0 8.718-3.91 8.718-8.736v-5.831h110.467V14.753c-62.204 0-115.888 44.554-127.72 105.96"
                  opacity=".4"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#004C90"
                  d="M255.622 120.713c-11.832-61.406-65.516-105.96-127.72-105.96V131.25h110.46v5.83c0 4.828 3.908 8.737 8.725 8.737 4.818 0 8.72-3.91 8.72-8.736v-14.567c0-.135-.178-1.772-.185-1.8"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#FFF"
                  d="M255.622 120.713c-11.832-61.406-65.516-105.96-127.72-105.96V131.25h110.46v5.83c0 4.828 3.908 8.737 8.725 8.737 4.818 0 8.72-3.91 8.72-8.736v-14.567c0-.135-.178-1.772-.185-1.8"
                  opacity=".1"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#004C90"
                  d="M62.308 118.606c-.59 1.182-.931 2.506-.931 3.909v14.567c0 4.82 3.901 8.735 8.719 8.735 4.817 0 8.726-3.916 8.726-8.735v-5.831h49.08V14.754c-32.56 0-59.675 44.696-65.594 103.852"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#FFF"
                  d="M62.308 118.606c-.59 1.182-.931 2.506-.931 3.909v14.567c0 4.82 3.901 8.735 8.719 8.735 4.817 0 8.726-3.916 8.726-8.735v-5.831h49.08V14.754c-32.56 0-59.675 44.696-65.594 103.852"
                  opacity=".3"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#004C90"
                  d="M193.501 118.606c-5.919-59.156-33.035-103.852-65.593-103.852V131.25h49.08v5.83c0 4.82 3.908 8.736 8.718 8.736 4.818 0 8.726-3.916 8.726-8.735v-14.567c0-1.403-.34-2.727-.93-3.909"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#FFF"
                  d="M193.501 118.606c-5.919-59.156-33.035-103.852-65.593-103.852V131.25h49.08v5.83c0 4.82 3.908 8.736 8.718 8.736 4.818 0 8.726-3.916 8.726-8.735v-14.567c0-1.403-.34-2.727-.93-3.909"
                  opacity=".2"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
                <path
                  fill="#000"
                  fillOpacity=".1"
                  d="M255.614 120.703C244.33 62.173 195.03 19.051 136.578 15.1V8.884c0-4.827-3.908-8.743-8.719-8.743v238.782c0 13.399-10.637 24.299-23.903 24.712.255.007.511.021.774.021 9.11 0 17.317-3.894 23.13-10.081 5.386-5.746 8.718-13.47 8.718-21.971V131.247h40.375v5.831c0 4.827 3.909 8.736 8.726 8.736 4.818 0 8.726-3.909 8.726-8.736v-5.83h43.95v5.83c0 4.827 3.9 8.736 8.725 8.736 4.818 0 8.72-3.909 8.72-8.736v-14.574c0-.128-.178-1.772-.186-1.8"
                  transform="translate(-923 -98) translate(0 98) translate(923) translate(57 68)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
